export const FEEDBACK_MODAL_SHOWN_KEY = 'FEEDBACK_MODAL_SHOWN_KEY';
